<template lang="pug">
.sideNav(v-if="currentService" :class="{'mobile': isMobile}")
    .top
        .service-plan-name
            span.plan(:class="(currentService?.formattedSpecs?.currentPlan?.label || '').toLowerCase().split(' ')[0]") {{ currentService?.formattedSpecs?.currentPlan?.label || '' }}
            .name {{ currentService?.service?.name || '' }}
        router-link.router(:to="`/my-services/${currentService.id}`" :class="{'active': route.name == 'service'}" data-track="sideNav_getting_started" @click="changeRoute(`/my-services/${currentService.id}`)")
            svg
                use(xlink:href="/material-icon.svg#icon-nav-home")
            span.name Getting Started
            
        router-link.router(:to="`/my-services/${currentService.id}/dashboard`" :class="{'active': route.name == 'dashboard'}" data-track="sideNav_service_settings" @click="changeRoute(`/my-services/${currentService.id}/dashboard`)")
            svg
                use(xlink:href="/material-icon.svg#icon-nav-setting")
            span.name Dashboard

        router-link.router(:to="`/my-services/${currentService.id}/users`" :class="{'active': route.name == 'users'}" data-track="sideNav_users" @click="changeRoute(`/my-services/${currentService.id}/users`)")
            svg
                use(xlink:href="/material-icon.svg#icon-nav-users")
            span.name Users

        router-link.router(:to="`/my-services/${currentService.id}/records`" :class="{'active': route.name == 'records'}" data-track="sideNav_records" @click="changeRoute(`/my-services/${currentService.id}/records`)")
            svg
                use(xlink:href="/material-icon.svg#icon-nav-database")
            span.name Database
            
        router-link.router(:to="`/my-services/${currentService.id}/openid`" :class="{'active': route.name == 'openid'}" data-track="sideNav_openid" @click="changeRoute(`/my-services/${currentService.id}/openid`)")
            svg
                use(xlink:href="/material-icon.svg#icon-nav-user-shield")
            span.name Open ID Logger

        router-link.router(:to="`/my-services/${currentService.id}/clientsecret`" :class="{'active': route.name == 'clientsecret'}" data-track="sideNav_clientsecret" @click="changeRoute(`/my-services/${currentService.id}/clientsecret`)")
            svg
                use(xlink:href="/material-icon.svg#icon-nav-lock")
            //- span.name Client Secret Key
            span.name Client Secret Keys


        .advanced-router
            div.router-wrap
                router-link.router(v-if="!isFreeMode" :to="`/my-services/${currentService.id}/mail`" :class="{'active': route.name == 'mail'}" data-track="sideNav_automated_email" @click="changeRoute(`/my-services/${currentService.id}/mail`)")
                    svg
                        use(xlink:href="/material-icon.svg#icon-nav-mail")
                    //- span.name Automated Email
                    span.name Automated Emails
                    
                router-link.router(v-if="!isFreeMode" :to="`/my-services/${currentService.id}/newsletter`" :class="{'active': route.name == 'newsletter'}" data-track="sideNav_bulk_email" @click="changeRoute(`/my-services/${currentService.id}/newsletter`)")
                    img(src="@/assets/img/myservice/bulk_email.svg" alt="Bulk Email icon")
                    //- span.name Bulk Email
                    span.name Newsletters

                router-link.router(:to="`/my-services/${currentService.id}/hosting`" :class="{'active': route.name == 'hosting'}" data-track="sideNav_file_hosting" @click="changeRoute(`/my-services/${currentService.id}/hosting`)")
                    svg
                        use(xlink:href="/material-icon.svg#icon-nav-hosting")
                    //- span.name File Hosting
                    span.name Web Hosting

    .bottom
        router-link.change-plan-button(:to='`/subscription/${currentService.id}`' data-track="sideNav_change_plan" v-if="canChangePlan")
            button.icon-text(type="button")
                .icon
                    svg
                        use(
                            xlink:href="/material-icon.svg#icon-custom-star"
                        )
                template(v-if="will_cancel")
                    | Resume Plan
                template(v-else)
                    | Upgrade Plan
</template>

<script setup>
import { useRoute, useRouter } from "vue-router";
import { onMounted, onUnmounted, ref, watch, computed } from "vue";
import { currentService } from "@/views/service-list";

const router = useRouter();
const route = useRoute();

const emit = defineEmits(["closeMobileMenu"]);
const isMobile = ref(false);

const checkMobile = () => {
    isMobile.value = window.innerWidth <= 800;
};

let will_cancel = computed(() => {
    if (!currentService.value) return false;
    const cancel_at = currentService.value.subscription?.cancel_at;
    return !!cancel_at || !!currentService.value.service?.will_terminate;
});
let canChangePlan = computed(() => {
    if (!currentService.value) return false;
    return !!currentService.value.formattedSpecs?.serviceStatus?.canChangePlan;
}); 

let isFreeMode = computed(() => {
    if (!currentService.value) return false;
    return (
        currentService.value.service?.group === 1 ||
        currentService.value.formattedSpecs?.currentPlan?.label === "Free"
    );
});

const changeRoute = (path) => {
    emit("closeMobileMenu");
    // 현재 라우트와 다를 때만 로딩바 표시
    // if (route.fullPath !== path) {
    //     fullScreenLoader();
    // }
};

// 라우트 변경 시 로딩바 표시
watch(
    () => route.fullPath,
    (n, o) => {
        if (n !== o) {
            const loaderEl = document.getElementById("full-screen-loader");
            if (loaderEl) loaderEl.remove();
        }
    }
);

onMounted(() => {
    checkMobile();
    window.addEventListener("resize", checkMobile);
});

onUnmounted(() => {
    window.removeEventListener("resize", checkMobile);
});
</script>

<style lang="less" scoped>
.sideNav {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    &.mobile {
        height: unset;

        .advanced-router {
            border-bottom: 1px solid rgba(255, 255, 255, 0.1);
        }

        .bottom {
            display: none;
        }
    }

    .bottom {
        padding: 16px;
    }

    .service-plan-name {
        padding: 40px 16px;
        text-align: center;

        .plan {
            color: #000;
            background-color: #888;
            font-size: 11px;
            padding: 4px 8px;
            border-radius: 5px;
            font-weight: 500;
            min-width: 64px;
            text-align: center;
            display: inline-block;
            // &.trial {
            //     background-color: #3c94ff;
            // }

            &.standard {
                background-color: #77dfa2;
            }

            &.premium {
                background-color: #f0e577;
            }

            &.canceled {
                background-color: var(--caution-color);
                color: #fff;
            }

            &.unlimited {
                background-color: #3c94ff;
                color: #000;
            }
        }

        .name {
            font-size: 16px;
            margin-top: 8px;
            word-break: break-word;
        }
    }

    .router {
        display: flex;
        align-items: center;
        gap: 8px;
        padding: 0.75rem 2.25rem;
        text-decoration: none;
        color: #f5f5f5;
        white-space: nowrap;
        user-select: none;

        &.active {
            background: #0d0d0d;
        }

        &:hover {
            background: #0d0d0d;
        }

        svg,
        img {
            width: 18px;
            height: 18px;
            fill: #f5f5f5;
        }

        .name {
            flex-grow: 1;
            font-size: 1rem;
        }
    }

    .advanced-router {
        padding: 1.5rem 0;
        margin: 1.5rem 0 0;
        border-top: 1px solid rgba(255, 255, 255, 0.1);
    }
}

@media (max-width: 430px) {
    .sideNav {
        .router {
            padding: 0.75rem 2rem;
        }
    }
}
</style>
